import { render, staticRenderFns } from "./PapercleanConfigurazioneCategorieListPage.vue?vue&type=template&id=4dceaa78&scoped=true"
import script from "./PapercleanConfigurazioneCategorieListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneCategorieListPage.vue?vue&type=script&lang=js"
import style0 from "./PapercleanConfigurazioneCategorieListPage.vue?vue&type=style&index=0&id=4dceaa78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceaa78",
  null
  
)

export default component.exports